export default __webpack_public_path__ + "locales/ja-JP/Ldap.json?hash=63baa14d36c8977e19c118664fa04d94";